var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrap-item" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "sk-dialog__footer flex justify-end items-center" },
      [
        _c(
          "el-button",
          {
            staticStyle: { "min-width": "110px" },
            attrs: {
              type: "primary",
              loading: _vm.isSaving,
              disabled: _vm.dirtyCount === 0 || _vm.isSaving,
            },
            on: { click: _vm.onSave },
          },
          [_vm._v("\n      Lưu điểm danh\n    ")]
        ),
        _c(
          "el-dropdown",
          {
            staticClass: "ml-2",
            attrs: { trigger: "click" },
            on: { command: _vm.handleExportCommand },
          },
          [
            _c(
              "el-button",
              {
                staticStyle: { "min-width": "110px" },
                attrs: { type: "success" },
              },
              [
                _vm._v("\n        Tác vụ "),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
              ]
            ),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c("el-dropdown-item", { attrs: { command: "constitutive" } }, [
                  _c("i", { staticClass: "el-icon-setting" }),
                  _vm._v(" Thiết lập điểm danh\n        "),
                ]),
                _c("el-dropdown-item", { attrs: { command: "by-date" } }, [
                  _c("i", { staticClass: "el-icon-download" }),
                  _vm._v(" Xuất file điểm danh ngày\n        "),
                ]),
                _c("el-dropdown-item", { attrs: { command: "by-month" } }, [
                  _c("i", { staticClass: "el-icon-download" }),
                  _vm._v(" Xuất file điểm danh tháng\n        "),
                ]),
                _c("el-dropdown-item", { attrs: { command: "general" } }, [
                  _c("i", { staticClass: "el-icon-download" }),
                  _vm._v(" Xuất file tổng hợp\n        "),
                ]),
                _c("el-dropdown-item", { attrs: { command: "general-date" } }, [
                  _c("i", { staticClass: "el-icon-download" }),
                  _vm._v(" Xuất file chi tiết tháng\n        "),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "margin-bottom": "12px" } }, [
      _c("p", { staticClass: "card-title" }, [_vm._v("Tác vụ")]),
      _c("p", { staticClass: "card-subtitle" }, [
        _vm._v("Lưu điểm danh, thiết lập và xuất file excel"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }